import React, { memo } from 'react';
import EntityDetail from 'containers/components/EntityDetail';
import { COMPANIES } from 'constants/Entities';

const CompaniesDetail = memo(() => <EntityDetail entity={COMPANIES} />);

export default CompaniesDetail;
